import axios from 'axios'

export const marketers = {
    state: {
        marketers:[],
        marketerById:{},
        communities:[],
        marketerAvailable:''
    },
    mutations:{
        marketers(state, data){
          state.marketers = data.marketers
        },
        marketerById(state,data){
          state.marketerById = data.marketer[0]
        },
        communities(state,data){
          state.communities = data
        },
        setMarketerAvailable(state, assessor) {
          state.marketerAvailable=assessor
        },
    },
    actions:{
        getMarketers: ({commit})=>{
            return new Promise((resolve, reject)=>{
                axios.get("/marketers")
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data);
                    commit("marketers", data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                });
              })
        },
        CommunityCodeName: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get("/communityCodeName")
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("communities", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },        
      getMarketingConsultantById: ({commit}, payload)=>{
            return new Promise((resolve, reject)=>{
                axios.get("/marketers/"+payload)
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data);
                    commit("marketerById", data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                });
            })
        },

        deleteMarketer: ({commit},payload)=>{
            return new Promise((resolve, reject)=>{
              axios.delete("/marketers/"+payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data)
                }
              })
              .catch((error)=>{
                reject(error);
              })
            });
          },

        AssignOrRemoveConsultant: ({commit}, payload)=>{
          return new Promise((resolve,reject)=>{
            axios.post("/assign/marketers", payload)
            .then(({status, data})=>{
              if(status===200){
                resolve(data)
              }
            })
            .catch((error)=>{
              reject(error)
            })
          })
        },

        registerMarketingConsultant: ({commit}, payload)=>{
          return new Promise((resolve,reject)=>{
            axios.post("/marketers", payload)
            .then(({status, data})=>{
              if(status===201){
                resolve(data)
              }
            })
            .catch((error)=>{
              reject(error)
            })
          })
        },

    // ================check if username is available================
    isMarketerAvailable ( { commit }, {username} ){
        return new Promise ((resolve,reject)=>{
          axios.get('/marketers/name/availability/' +username)
          .then((data)=>{
            resolve(data.data.isAvailable)
            const assessor = data.data.isAvailable
            commit ('setMarketerAvailable', assessor)
            console.log(assessor);
          })
          .catch((error)=>{
              reject(error)
              console.log(error)
          })
        })
    },

        
    }
}